import Api from 'util/Api';
import API from 'constants/api';
import { Paquer } from 'interfaces/paquer';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { authProfile } from 'redux/auth/selectors';

export const getById = async (id: string | number | null | undefined) => {
  const response = await Api.apiAxios.get(`${API.paquer.getById}${id}`);
  const routes: Paquer = response.data.data;

  return routes;
};

const getPackagesInPower = async (driverId: number) => {
  const searchParams = new URLSearchParams({
    search: '',
    page: '0',
    take: '10000',
    size: '10000',
    desc: 'false',
    searchRolled: '',
  });
  const packages = await Api.apiAxios.get(
    `${API.paquer.getPackages}${driverId}?${searchParams.toString()}`,
  );
  return packages.data.data.content;
};

export const useDriverPackages = (driverId?: number) => {
  return useQuery({
    queryKey: ['driverPackages', driverId],
    queryFn: async () => await getPackagesInPower(driverId!),
    placeholderData: [],
    retry: 1,
    enabled: !!driverId,
  });
};

const getDrivers = async () => {
  const searchParams = new URLSearchParams({
    size: '10000',
    search: '',
  });
  const paquers = await Api.apiAxios.get(
    `${API.paquer.getAll}?${searchParams.toString()}`,
  );
  return paquers.data.data.content;
};

export const useDrivers = () => {
  const profile = useSelector(authProfile);
  // Los roles de OPL no tienen paquerypoint asignado: el backend ya acota los
  // drivers por el token, así que no se puede condicionar la query al PP.
  return useQuery({
    queryKey: ['paquers', profile?.paquerypoint?.id ?? 'opl'],
    queryFn: getDrivers,
    retry: 1,
    placeholderData: [],
    staleTime: 300000,
    enabled: !!profile,
  });
};
